import Vue from "vue";
import Vuetify from "vuetify/lib";
import i18n from "@/i18n";
import "@/sass/overrides.sass";

Vue.use(Vuetify);

const theme = {
  primary: "#f65d5d",
  // primary: '#4267B2',
  success: "#f65d5d",
  // primary: 'primary',
  secondary: "#f65d5d",
  accent: "#f65d5d",
  info: "#f65d5d",
};

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
});
